var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.57129 3C5.12357 3 5.57129 3.44772 5.57129 4V17C5.57129 18.1046 6.46672 19 7.57129 19H20.5713C21.1236 19 21.5713 19.4477 21.5713 20C21.5713 20.5523 21.1236 21 20.5713 21H7.57129C5.36215 21 3.57129 19.2091 3.57129 17V4C3.57129 3.44772 4.019 3 4.57129 3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2784 16.7071C18.8879 17.0976 18.2547 17.0976 17.8642 16.7071L15.8642 14.7071C15.4737 14.3166 15.4737 13.6834 15.8642 13.2929C16.2547 12.9024 16.8879 12.9024 17.2784 13.2929L17.5713 13.5858V11C17.5713 7.68629 14.885 5 11.5713 5H8.57129C8.019 5 7.57129 4.55229 7.57129 4C7.57129 3.44771 8.019 3 8.57129 3H11.5713C15.9896 3 19.5713 6.58172 19.5713 11V13.5858L19.8642 13.2929C20.2547 12.9024 20.8879 12.9024 21.2784 13.2929C21.6689 13.6834 21.6689 14.3166 21.2784 14.7071L19.2784 16.7071Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineDown);
export default __webpack_public_path__ + "static/media/line-down.dcff79d5ca851c17187de45e4c359ab7.svg";
export { ForwardRef as ReactComponent };